









































import { Response, Question } from '@/store/modules/survey-store-module'
import { Component, Prop, Vue } from 'vue-property-decorator'
import OpenEnds from './OpenEnds.vue'
import CollapsibleSectionWithHeader from '@/components/Survey/CollapsibleSectionWithHeader.vue'
import { NestedResponses, DoubleNestedResponses } from '@/components/Survey/Utilities/ChartUtilities'

@Component({
  name: 'GroupedOpenEnds',
  components: {
    OpenEnds,
    CollapsibleSectionWithHeader
  }
})
export default class extends Vue {
  @Prop({ required: true }) responses!: Response[] | NestedResponses | DoubleNestedResponses
  @Prop({ required: true }) question!: Question
  @Prop({ required: true }) sortedCategories!: string[]
  @Prop({ required: true }) filter!: string
  @Prop({ required: false }) totalResponseCount!: number

  isRecordWithEntries (value: Response[] | NestedResponses | DoubleNestedResponses) {
    return !!value && !Array.isArray(value) && Object.keys(value).length
  }

  get categories () {
    // Shouldn't need this but it implies the type and is good safety
    if (!this.responses || Array.isArray(this.responses)) return []

    const keys = Object.keys(this.responses)
    if (Array.isArray(this.responses[keys[0]])) {
      // If we're getting down the response array, we want the sorted categories
      // to display in order
      return this.sortedCategories
    } else {
      // Recursive nature of this component hits the demographic keys / variant keys first
      return keys
    }
  }
}
